import React from "react";
import moment from 'moment';
import withSnackbar from "../../../util/withSnackbar";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import { SNACKBAR_OPTIONS, DATE_FORMAT, TIMEOUT } from '../../../constants/CommonConstants';
import { AvailabilityResultsGraph } from "../parts/AvailabilityResultsGraph";
import { LinearProgress } from '@mui/material';
import cognitoAuth from "../../../util/Cognito";
import Header from "../../CeHeader/Header";
import zoomButtonIcon from "../../../img/img_Fullscreen_off.svg"
import { errorHandle } from '../../../Common/errorHandle';
import "./FullScreenAvailabilityResultsGraph.css";
import { refreshPageDetail } from '../../../Common/ChangeHeaderDate';
import { dateIsSame } from "../../../util/util";

class FullScreenAvailabilityResultsGraph extends React.Component {
    
    constructor(props) {
        super(props);

        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});

        this.goToPreviousScreen = this.goToPreviousScreen.bind(this);
        this.changeToPrevious = this.changeToPrevious.bind(this);
        this.changeToNext = this.changeToNext.bind(this);
        this.resetPeriod = this.resetPeriod.bind(this);
        this.changeDateHeader = this.changeDateHeader.bind(this);
        this.state = {
            isProgress: false,
            analysisDataList: [],
            displayName: 'AvailabilityResultsGraph',
            userName: this.props.location.state.userName,
            baseDate: this.props.location.state.baseDate ? this.props.location.state.baseDate : moment(today).day(0).format(DATE_FORMAT),
            oneBeforeDate: this.props.location.state.oneBeforeDate ? this.props.location.state.oneBeforeDate : moment(today).day(0).subtract(7, 'days').format(DATE_FORMAT),
            isInitDate: this.props.location.state.baseDate === moment(today).day(0).format(DATE_FORMAT),
        };
    }

    componentDidMount() {
      this.getAnalysis();   
    }

    getAnalysis() {
        this.setState({isProgress:true});
        let header = {
            'Authorization': ''
        };
        
        this.setState({isProgress: true});
        cognitoAuth.getAuthorizationToken().then((token) => {
            header.Authorization = token;
        }, (error) => {
            throw error;
        }).then(() => {
            const controller = new AbortController();
            const props = this;
            const timer = window.setTimeout(errorHandle(function() {
                controller.abort();
                throw props;
            }), TIMEOUT);
            let printListQs = new URLSearchParams({
                userId: this.state.userName,
                from: this.state.oneBeforeDate,
                to: moment(this.state.baseDate).add(-1, 'days').format(DATE_FORMAT)
            });
            let getOperatorInfo = fetch(process.env.REACT_APP_CE_OPERATOR_INFO + `?${printListQs}`, {
                method: "GET",
                headers: header,
                signal: controller.signal,
            });
            
            Promise.all([getOperatorInfo]).then(responses => {
                window.clearTimeout(timer);
                this.setState({isProgress: false});
                for (let response of responses) {
                    if (!response.ok) {
                        if (response.status === 408) {
                            // エラーメッセージ表示
                            this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_connection_error" }));
                            return;
                        } else {
                            // エラーメッセージ表示
                            this.props.openSnackbar(this.props.intl.formatMessage({ id: "http_get_error" }, {status: response.status}));
                            return;
                        }
                    }
                }

                Promise.all(responses.map(res => res.json())).then(results => {
                    const{ baseDate, oneBeforeDate } = this.state;
                    if(dateIsSame(baseDate, oneBeforeDate, results[0].startDate, results[0].endDate)) {
                        this.setState({
                            analysisDataList: results[0].printDetail.analysisResult
                        });
                    }
                });
            });
        }).catch(() => {
            this.setState({isProgress: false});
            cognitoAuth.sessionTimeOut(this.props);
        });
    }

    goToPreviousScreen() {
        this.props.history.replace({
            pathname: '/ce/operatorTop',
            search: '?id=' + this.state.userName,
            state:{
                baseDate: this.state.baseDate,
                oneBeforeDate: this.state.oneBeforeDate,
            }
        });
    }

    changeDateHeader(startDate,endDate){
        refreshPageDetail(startDate,endDate,this,'FullScreenAvailabilityResultsGraph');
        this.getAnalysis();
    }

    changeToPrevious() {
        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});
        let previousBaseDate = moment(this.state.baseDate, DATE_FORMAT).add(-7, 'days').format(DATE_FORMAT);

        this.setState({
            baseDate: previousBaseDate,
            oneBeforeDate: moment(this.state.oneBeforeDate, DATE_FORMAT).add(-7, 'days').format(DATE_FORMAT),
            isInitDate: previousBaseDate === moment(today).day(0).format(DATE_FORMAT),
        });
        this.getAnalysis();
    }

    changeToNext() {
        
        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});
        let nextBaseDate = moment(this.state.baseDate, DATE_FORMAT).add(7, 'days').format(DATE_FORMAT);

        this.setState({
            baseDate : nextBaseDate,
            oneBeforeDate: moment(this.state.oneBeforeDate, DATE_FORMAT).add(7, 'days').format(DATE_FORMAT),
            isInitDate: nextBaseDate === moment(today).day(0).format(DATE_FORMAT),
        });
        this.getAnalysis();
    }

    resetPeriod() {
        let today = moment().set({hour:0,minute:0,second:0,millisecond:0});
        if(this.state.baseDate !== moment(today).day(0).format(DATE_FORMAT)) {
            this.setState({
                baseDate: moment(today).day(0).format(DATE_FORMAT),
                oneBeforeDate: moment(today).day(0).subtract(7, 'days').format(DATE_FORMAT),
                isInitDate: true,
            });
            this.getAnalysis();
        }
    }

    render() {
        return (
            <div id="AvailabilityResultsGraphContents" className="contents">
                {this.state.isProgress ? <LinearProgress /> : ''}
                <Header showSubMenu={true}
                    resetPeriod={this.resetPeriod}
                    beginDate={moment(this.state.oneBeforeDate, DATE_FORMAT)}
                    endDate={moment(this.state.baseDate, DATE_FORMAT).add(-1, 'days')}
                    changeToPrevious={this.changeToPrevious}
                    changeToNext={this.changeToNext} 
                    isInitDate={this.state.isInitDate}
                    changeDateHeader={this.changeDateHeader}
                />
                <div className={this.state.isProgress ? 'content-body' : 'content-body show'}>
                    <div className="content-title">{this.props.intl.formatMessage({ id: "top_operator_title_production_result" })}</div>
                    <div className="graph-area">
                        <AvailabilityResultsGraph intl={this.props.intl} analysisDataList={this.state.analysisDataList} onFullScreenButtonClick={this.goToPreviousScreen} zoomButtonIcon={zoomButtonIcon}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default withSnackbar(withRouter(injectIntl(FullScreenAvailabilityResultsGraph)), SNACKBAR_OPTIONS);
